parasails.registerPage('rally', {
  //  ╦╔╗╔╦╔╦╗╦╔═╗╦    ╔═╗╔╦╗╔═╗╔╦╗╔═╗
  //  ║║║║║ ║ ║╠═╣║    ╚═╗ ║ ╠═╣ ║ ║╣
  //  ╩╝╚╝╩ ╩ ╩╩ ╩╩═╝  ╚═╝ ╩ ╩ ╩ ╩ ╚═╝
  data: {
    eventID: '',
    overallEventID: '',
    deviceidentifier: '',
    eventType: '',
    partType: '',
    eventData: {},
    eventIsLive: false,
    partIsLive: false,
    partIndex: 0,
    pleaseWait: true,
    currentPartData: {},
    backgroundStyle: 'background-image: url("../images/Visibby汎用BG.png");',
    additionalstyle: '-webkit-background-size: cover !important; -moz-background-size: cover !important; -o-background-size: cover !important; background-size: cover !important; background-repeat: no-repeat !important; display: flex !important; align-items: center !important; align-content: center !important; justify-content: center !important; flex-wrap: nowrap !important; background-position: center !important;',
    eventLogo: 'images/caramel-logo.png',
    freeSwitch: false,
    subLogo: '',
    keyhackval: 0,
    showFooter: true,
    useDarkLogos: true,
    rallyData: {
      bg: '',
      collected: [],
      stamps: [],
      gpsON: true
    },
    stampLayoutBGStyle: '',
    requirePosition: true,
    showAllStampsForSetup: false,
    isAnimatingReveal: false,
    revealQueue: [],
    stampRevealDurationMs: 900,
    stampRevealStartScale: 3,
    stampDisplayScale: 2.5,
    stampReveal: {
      active: false,
      imagePath: '',
      stampID: '',
      left: '0px',
      top: '0px',
      width: '0px',
      height: '0px',
      startDeltaX: '0px',
      startDeltaY: '0px',
      rotation: 0
    },
    showDownloadModal: false,
    showInfoPopup: false,
    showQrScanner: false,
    qrScannerError: '',
    isMainDownloadButtonPressed: false,
    pressedRewardButton: null,
    downloadRewards: [
      { stampCount: 3, fileName: 'yh_best_history_a.jpg', filePath: 'images/rally/hirose2026/downloads/yh_best_history_a.jpg' },
      { stampCount: 6, fileName: 'yh_best_history_b.jpg', filePath: 'images/rally/hirose2026/downloads/yh_best_history_b.jpg' },
      { stampCount: 9, fileName: 'yh_best_history_c.jpg', filePath: 'images/rally/hirose2026/downloads/yh_best_history_c.jpg' },
      { stampCount: 12, fileName: 'yh_best_history_d.jpg', filePath: 'images/rally/hirose2026/downloads/yh_best_history_d.jpg' }
    ],
    loading: false,
    showToast: false,
    toastTitle: 'GPS',
    toastLines: [
      'スタンプを集めるには、',
      'GPS位置情報サービスが必要です。'
    ]
  },

  //  ╦  ╦╔═╗╔═╗╔═╗╦ ╦╔═╗╦  ╔═╗
  //  ║  ║╠╣ ║╣ ║  ╚╦╝║  ║  ║╣
  //  ╩═╝╩╚  ╚═╝╚═╝ ╩ ╚═╝╩═╝╚═╝
  beforeMount: function() {
    //…
  },
  beforeDestroy: function() {
    this.closeQrScanner();
  },
  mounted: async function() {
    if(!this.eventData) {
      window.location.href = '/linkexpired';
      return;
    }

    const urlParams = new URLSearchParams(window.location.search);
    this.overallEventID = urlParams.get('eventID');
    var awardStampID = urlParams.get('awardStampID') || '';
    this.eventID = this.eventData.id;
    this.setBGStyle(false);
    this.setLogo();

    if(this.eventData.eventType.length > 0) {
      this.eventType = this.eventData.eventType[0].name;
      this.deviceidentifier = this.eventData.deviceidentifier;
      this.eventIsLive = this.eventData.isLive;
    }
    if(this.eventData.parts.length > 0) {
      var rallyPartIndex = this.eventData.parts.findIndex((part) => part.partType === 'rally');

      if(rallyPartIndex >= 0) {
        this.partIndex = rallyPartIndex;
      } else {
        for(var pi = 0; pi < this.eventData.parts.length; pi++) {
          if(this.eventData.parts[pi].isLive) {
            this.partIndex = pi;
            break;
          }
        }
      }

      this.currentPartData = this.eventData.parts[this.partIndex] || {};
      this.partIsLive = this.currentPartData.isLive;
    }
    this.setupRally();

    var awardStamp = this.rallyData.stamps.find((stamp) => String(stamp.id) === String(awardStampID));
    var normalizedAwardStampID = awardStamp ? awardStamp.id : awardStampID;
    if (awardStamp && this.rallyData.collected.some((stampID) => String(stampID) === String(awardStampID))) {
      this.rallyData.collected = this.rallyData.collected.filter((stampID) => String(stampID) !== String(awardStampID));
      this.$nextTick(() => {
        this.showStamp(normalizedAwardStampID);
      });
    }
  },

  //  ╦╔╗╔╔╦╗╔═╗╦═╗╔═╗╔═╗╔╦╗╦╔═╗╔╗╔╔═╗
  //  ║║║║ ║ ║╣ ╠╦╝╠═╣║   ║ ║║ ║║║║╚═╗
  //  ╩╝╚╝ ╩ ╚═╝╩╚═╩ ╩╚═╝ ╩ ╩╚═╝╝╚╝╚═╝
  methods: {
    setLogo() {
      if(this.eventData.logoImage) {
        this.eventLogo = this.eventData.logoImage;
      }
      if(this.eventData.subLogoImage) {
        this.subLogo = this.eventData.subLogoImage;
      }
    },
    setBGStyle(isPart) {
      var bgImage = '../images/Visibby汎用BG.png';
      var bgIsColor = false;
      // var additionalstyle = '-webkit-background-size: cover !important; -moz-background-size: cover !important; -o-background-size: cover !important; background-size: cover !important; background-repeat: no-repeat !important; background-color: #000000 !important; display: flex !important; align-items: center !important; align-content: center !important; justify-content: center !important; flex-wrap: nowrap !important; background-position: center !important;';
      if(isPart) {
        //before checking the part bg, check the if this is a vote and has a bg set for each question...
        if(this.currentPartData) {
          if((this.currentPartData.partType === 'vote' || this.currentPartData.partType === 'qa' || this.currentPartData.partType === 'quiz')) {
            if(this.currentPartData.questions[this.questionIndex].bgMode === 'COLOR') {
              bgImage = this.currentPartData.questions[this.questionIndex].bgcolor; //Reusing the bgImage variable for color. Lets make it less ambiguosu when there is time.
              bgIsColor = true;
            } else if(this.currentPartData.questions[this.questionIndex].bgimage && this.currentPartData.questions[this.questionIndex].bgimage !== '') {
              bgImage = this.currentPartData.questions[this.questionIndex].bgimage;
            }
          } else if(this.currentPartData && this.currentPartData.BGImage && this.currentPartData.BGImage !== '') {
            bgImage = this.currentPartData.BGImage;
          } else {
            if(this.eventData.BGImage && this.eventData.BGImage !== '') {
              bgImage = this.eventData.BGImage;
            }
          }
        } else if(this.eventData.BGImage && this.eventData.BGImage !== '') {
          bgImage = this.eventData.BGImage;
        }
      } else {
        if(this.eventData.BGImage && this.eventData.BGImage !== '') {
          bgIsColor = this.eventData.BGImage.startsWith('#') === true;
          bgImage = this.eventData.BGImage;
        }
      }
      if(bgIsColor === true) {
        this.backgroundStyle = this.additionalstyle + ' background-color: ' + bgImage.toLowerCase() + ' !important;';
      } else {
        this.backgroundStyle = 'background-image: url(\'' + bgImage + '\') !important; ' + this.additionalstyle;
      }
    },
    setupRally() {
      //Set the rally stamps layout image...
      if(this.currentPartData.rally) {
        this.rallyData.bg = (this.currentPartData.rally.stampBGImage) ? this.currentPartData.rally.stampBGImage : '';
        this.rallyData.gpsON = this.currentPartData.rally.gpsON !== false;
        this.requirePosition = this.rallyData.gpsON;
        this.rallyData.stamps = (this.currentPartData.rally.stamps || []).map((stamp) => {
          return {
            id: stamp.id,
            imagePath: this.resolveStampImagePath(stamp.image),
            top: stamp.top || 0,
            left: stamp.left || 0,
            rotation: stamp.rotation || 0,
            activeDate: this.normalizeDateString(stamp.activeDate),
            clickAction: stamp.clickAction || '',
            autoAction: {
              action: stamp.autoAction && stamp.autoAction.action ? stamp.autoAction.action : '',
              delay: stamp.autoAction && Number.isFinite(Number(stamp.autoAction.delay)) ? Math.max(0, Number(stamp.autoAction.delay)) : 0
            }
          };
        });

        if(this.rallyData.bg !== '') {
          this.stampLayoutBGStyle = ' background-image: url(\'' + this.rallyData.bg + '\'); background-size: contain !important; background-repeat: no-repeat !important; background-position: center !important;';
        }

        if(this.collectedStampsData && this.collectedStampsData.length > 0) {
          for(var i = 0; i < this.collectedStampsData.length; i++) {
            this.showStamp(this.collectedStampsData[i].stampID, false);
          }
        }
      }

      //"top" : NumberInt(25),
      // "left" : NumberInt(0),
      // "rotation" : NumberInt(-25)
    },
    collectStamp(stampID) {
      io.socket.post('/collect-stamp', { eventID: this.eventID, userID: this.eventData.userID, stampID: stampID});
    },
    resolveStampImagePath(imagePath) {
      if(!imagePath || imagePath === '') {
        return '';
      }

      if(imagePath.startsWith('http://') || imagePath.startsWith('https://') || imagePath.startsWith('/') || imagePath.startsWith('../') || imagePath.startsWith('images/')) {
        return imagePath;
      }

      if(this.rallyData.bg && this.rallyData.bg.includes('/')) {
        var bgFolder = this.rallyData.bg.substring(0, this.rallyData.bg.lastIndexOf('/') + 1);
        return bgFolder + imagePath;
      }

      return imagePath;
    },
    getStampByID(stampID) {
      return this.rallyData.stamps.find((stamp) => stamp.id === stampID);
    },
    getStampElement(stampID) {
      return this.$el.querySelector('[data-stamp-id="' + stampID + '"]');
    },
    getStampRevealStyle() {
      return {
        left: this.stampReveal.left,
        top: this.stampReveal.top,
        width: this.stampReveal.width,
        height: this.stampReveal.height,
        '--reveal-start-delta-x': this.stampReveal.startDeltaX,
        '--reveal-start-delta-y': this.stampReveal.startDeltaY,
        '--reveal-start-scale': this.stampRevealStartScale,
        '--reveal-rotation': this.stampReveal.rotation + 'deg',
        '--reveal-duration': this.stampRevealDurationMs + 'ms'
      };
    },
    getStampStyle(stamp) {
      return {
        visibility: (this.showAllStampsForSetup || this.rallyData.collected.includes(stamp.id)) ? 'visible' : 'hidden',
        top: stamp.top + '%',
        left: stamp.left + '%',
        transform: 'translate(80%, 80%) scale(' + this.stampDisplayScale + ') rotate(' + stamp.rotation + 'deg)'
      };
    },
    getCollectedStampCount() {
      return this.rallyData.collected.length;
    },
    canDownloadReward(stampCount) {
      return this.getCollectedStampCount() >= stampCount;
    },
    openDownloadModal() {
      this.showDownloadModal = true;
      this.setMainDownloadButtonPressed(false);
    },
    closeDownloadModal() {
      this.showDownloadModal = false;
      this.pressedRewardButton = null;
    },
    handleStampClick(stamp) {
      if(!stamp) {
        return;
      }

      this.runStampAction(stamp, stamp.clickAction);
    },
    runStampAction(stamp, action) {
      if(!stamp || !action) {
        return;
      }

      switch(action) {
        case 'infoPopup':
          if(this.getCollectedStampCount() === this.rallyData.stamps.length) {
            this.showInfoPopup = true;
          }
          break;
        default:
          console.warn('Unknown rally stamp action: ' + action);
      }
    },
    runAutoAction(stamp) {
      if(!stamp || !stamp.autoAction || !stamp.autoAction.action) {
        return;
      }

      window.setTimeout(() => {
        this.runStampAction(stamp, stamp.autoAction.action);
      }, stamp.autoAction.delay);
    },
    closeInfoPopup() {
      this.showInfoPopup = false;
    },
    setMainDownloadButtonPressed(isPressed) {
      this.isMainDownloadButtonPressed = isPressed === true;
    },
    getMainDownloadButtonImage() {
      if(this.isMainDownloadButtonPressed) {
        return 'images/rally/hirose2026/button_download_main_tap.webp';
      }
      return 'images/rally/hirose2026/button_download_main_active.webp';
    },
    setRewardButtonPressed(stampCount, isPressed) {
      if(!this.canDownloadReward(stampCount)) {
        this.pressedRewardButton = null;
        return;
      }

      this.pressedRewardButton = isPressed === true ? stampCount : null;
    },
    getRewardButtonImage(stampCount) {
      if(!this.canDownloadReward(stampCount)) {
        return 'images/rally/hirose2026/button_download-' + stampCount + 'stamps_out.webp';
      }
      if(this.pressedRewardButton === stampCount) {
        return 'images/rally/hirose2026/button_download-' + stampCount + 'stamps_tap.webp';
      }
      return 'images/rally/hirose2026/button_download-' + stampCount + 'stamps_active.webp';
    },
    downloadReward(reward) {
      if(!reward || !this.canDownloadReward(reward.stampCount)) {
        return;
      }

      this.pressedRewardButton = null;
      this.triggerDownloadFile(reward.filePath, reward.fileName);
    },
    async triggerDownloadFile(filePath, fileName) {
      var downloadName = fileName || 'download-file';

      try {
        var response = await fetch(filePath);
        if(!response.ok) {
          throw new Error('HTTP error ' + response.status);
        }

        var downloadUrl = window.URL.createObjectURL(await response.blob());
        var downloadLink = document.createElement('a');
        downloadLink.href = downloadUrl;
        downloadLink.download = downloadName;
        downloadLink.rel = 'noopener';
        downloadLink.style.display = 'none';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
        window.URL.revokeObjectURL(downloadUrl);
      } catch(err) {
        console.error('Error downloading rally reward:', err);
        var fallbackLink = document.createElement('a');
        fallbackLink.href = filePath;
        fallbackLink.download = downloadName;
        fallbackLink.rel = 'noopener';
        fallbackLink.style.display = 'none';
        document.body.appendChild(fallbackLink);
        fallbackLink.click();
        fallbackLink.remove();
      }
    },
    normalizeDateString(dateValue) {
      if(!dateValue) {
        return '';
      }

      if(typeof dateValue === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateValue)) {
        return dateValue;
      }

      var parsedDate = new Date(dateValue);
      if(Number.isNaN(parsedDate.getTime())) {
        return '';
      }

      return this.getDateString(parsedDate);
    },
    getDateString(dateObj) {
      var year = dateObj.getFullYear();
      var month = String(dateObj.getMonth() + 1).padStart(2, '0');
      var day = String(dateObj.getDate()).padStart(2, '0');
      return year + '-' + month + '-' + day;
    },
    showGpsToast() {
      this.toastTitle = 'GPS';
      this.toastLines = [
        'スタンプを集めるには、',
        'GPS位置情報サービスが必要です。'
      ];
      this.showToast = true;
    },
    enqueueReveal(stampID) {
      if(!this.revealQueue.includes(stampID)) {
        this.revealQueue.push(stampID);
      }
    },
    showStamp(stampID, animateReveal = true) {
      if(this.rallyData.collected.includes(stampID)) {
        return;
      }

      if(animateReveal !== true) {
        this.rallyData.collected.push(stampID);
        return;
      }

      if(this.isAnimatingReveal) {
        this.enqueueReveal(stampID);
        return;
      }

      this.startStampReveal(stampID);
    },
    async startStampReveal(stampID) {
      var stamp = this.getStampByID(stampID);
      var stampElement = this.getStampElement(stampID);
      var mainElement = this.$el.querySelector('main');

      if(!stamp || !stampElement || !mainElement) {
        if(!this.rallyData.collected.includes(stampID)) {
          this.rallyData.collected.push(stampID);
        }
        this.runAutoAction(stamp);
        this.processNextReveal();
        return;
      }

      this.isAnimatingReveal = true;

      var mainRect = mainElement.getBoundingClientRect();
      var stampRect = stampElement.getBoundingClientRect();
      var centerX = mainRect.left + (mainRect.width / 2);
      var centerY = mainRect.top + (mainRect.height / 2);
      // Center point is unaffected by rotation, but getBoundingClientRect's
      // width/height is the rotated bounding box (bigger than the real image),
      // so the overlay's box must be derived from the unrotated element size
      // instead, or it'll render visibly larger than the real stamp.
      var targetX = stampRect.left + (stampRect.width / 2);
      var targetY = stampRect.top + (stampRect.height / 2);
      var finalWidth = stampElement.offsetWidth * this.stampDisplayScale;
      var finalHeight = stampElement.offsetHeight * this.stampDisplayScale;

      this.stampReveal.imagePath = stamp.imagePath;
      this.stampReveal.stampID = stamp.id;
      this.stampReveal.left = (targetX - mainRect.left - (finalWidth / 2)) + 'px';
      this.stampReveal.top = (targetY - mainRect.top - (finalHeight / 2)) + 'px';
      this.stampReveal.width = finalWidth + 'px';
      this.stampReveal.height = finalHeight + 'px';
      this.stampReveal.startDeltaX = (centerX - targetX) + 'px';
      this.stampReveal.startDeltaY = (centerY - targetY) + 'px';
      this.stampReveal.rotation = stamp.rotation || 0;
      this.stampReveal.active = true;

      await this.$nextTick();

      window.setTimeout(() => {
        if(!this.rallyData.collected.includes(stampID)) {
          this.rallyData.collected.push(stampID);
        }
        this.runAutoAction(stamp);
        this.stampReveal.active = false;
        this.isAnimatingReveal = false;
        this.processNextReveal();
      }, this.stampRevealDurationMs);
    },
    processNextReveal() {
      while(this.revealQueue.length > 0) {
        var nextStampID = this.revealQueue.shift();
        if(!this.rallyData.collected.includes(nextStampID)) {
          this.startStampReveal(nextStampID);
          return;
        }
      }
    },
    getLocation() {
      if(navigator.geolocation) {
        this.loading = true;
        navigator.geolocation.getCurrentPosition(          // this.showPosition(position);
          (position) => {
            this.showPosition(position);
          },
          (error) => {
              this.loading = false; // Set loading to false on error
              this.showGpsToast();
          }
        );
      } else {
        console.log('Geolocation is not supported');
        this.loading = false;
        this.showGpsToast();
      }
    },
    async showPosition(position) {
      try
      {
        var locationObject = {
          type: 'point',
          coordinates: [position.coords.longitude, position.coords.latitude]
        };

        var dataDistance = (this.currentPartData.rally.distance) ? this.currentPartData.rally.distance : 0.3;
        console.log("dataDistance" + this.currentPartData.rally.distance);
        var nearbyStamps = await Cloud.checkStampLocation.with({partID: this.currentPartData.id.toString(), lon: position.coords.longitude, lat: position.coords.latitude, distance: dataDistance});
        if(nearbyStamps) {
          nearbyStamps.forEach(part => {
            part.stamps.forEach(stamp => {
              this.showStamp(stamp.id);
              this.collectStamp(stamp.id);
            });
          });
        }
      } catch(e) {
        console.log('Error getting position: ' + e);
      }
      this.loading = false;
    },
    openQrScanner() {
      this.qrScannerError = '';
      this.showQrScanner = true;
      this.$nextTick(() => {
        this.startQrScanner();
      });
    },
    async startQrScanner() {
      if(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        this.qrScannerError = 'Camera access is not supported on this device. Please use your phone\'s camera app to scan the code instead.';
        return;
      }
      try {
        this.qrStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'environment' } });
      } catch(e) {
        console.log('Error accessing camera: ' + e);
        this.qrScannerError = 'Camera access is required to scan a QR code.';
        return;
      }
      if(!this.showQrScanner) {
        // Scanner was closed while permission was pending.
        this.qrStream.getTracks().forEach((track) => track.stop());
        this.qrStream = null;
        return;
      }
      var video = this.$refs.qrVideo;
      video.srcObject = this.qrStream;
      await video.play();

      if('BarcodeDetector' in window) {
        var detector = new window.BarcodeDetector({ formats: ['qr_code'] });
        this.qrScanLoop(detector, video);
        return;
      }
      // Safari/iOS has no BarcodeDetector, so decode frames in-page with jsQR instead.
      if(typeof window.jsQR !== 'function') {
        this.qrScannerError = 'QR scanning is not supported in this browser. Please use your phone\'s camera app to scan the code instead.';
        return;
      }
      this.qrScanLoopJsQR(video);
    },
    qrScanLoop(detector, video) {
      if(!this.showQrScanner) {
        return;
      }
      detector.detect(video).then((codes) => {
        if(codes.length > 0 && codes[0].rawValue) {
          this.handleQrScanResult(codes[0].rawValue);
          return;
        }
        this.qrScanFrame = requestAnimationFrame(() => this.qrScanLoop(detector, video));
      }).catch(() => {
        this.qrScanFrame = requestAnimationFrame(() => this.qrScanLoop(detector, video));
      });
    },
    qrScanLoopJsQR(video) {
      if(!this.showQrScanner) {
        return;
      }
      if(video.readyState === video.HAVE_ENOUGH_DATA) {
        var canvas = this.$refs.qrCanvas;
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        var context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        var imageData = context.getImageData(0, 0, canvas.width, canvas.height);
        var code = window.jsQR(imageData.data, imageData.width, imageData.height);
        if(code && code.data) {
          this.handleQrScanResult(code.data);
          return;
        }
      }
      this.qrScanFrame = requestAnimationFrame(() => this.qrScanLoopJsQR(video));
    },
    handleQrScanResult(scannedValue) {
      this.closeQrScanner();
      try {
        var scannedUrl = new URL(scannedValue, window.location.href);
        window.location.href = scannedUrl.href;
      } catch(e) {
        console.log('Scanned QR value is not a valid URL: ' + scannedValue);
      }
    },
    closeQrScanner() {
      this.showQrScanner = false;
      if(this.qrScanFrame) {
        cancelAnimationFrame(this.qrScanFrame);
        this.qrScanFrame = null;
      }
      if(this.qrStream) {
        this.qrStream.getTracks().forEach((track) => track.stop());
        this.qrStream = null;
      }
    }
  }
});
